import { Dispatch } from 'redux';

import { requestHandler } from '../../../api';

export const getAllFactoringReSelling = async (
  dispatch: Dispatch,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/reSell/factoring?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getAllActiveResellsForFund = async (
  dispatch: Dispatch,
  fundId: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/reSell/fund/${fundId}/resells/active`,
    dispatch,
  });
  if (response) return response.data;
};

export const getAllFactoringReSellingNominees = async (
  dispatch: Dispatch,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/reSell/factoring/nominees?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const updateFactoringNomineeAmountToReceive = async (
  dispatch: Dispatch,
  nomineeId: number,
  amountToReceive: number,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/reSell/factoring/nominees/amountToReceive`,
    data: {
      nomineeId,
      amountToReceive,
    },
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentsAvailableForReSelling = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/reSell/documents/available`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentsAvailableForReplacement = async (
  dispatch: Dispatch,
  id: string,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/reSell/factoring/${id}/available-documents-for-replacement?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const replaceResellDocument = async (
  dispatch: Dispatch,
  id: string,
  data: { newDocumentId: string },
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/reSell/factoring/${id}/replace-document`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const createFactoringReSell = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/reSell/factoring`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const createFactoringReSellBatch = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/reSell/factoring/batch`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getFactoringReSell = async (dispatch: Dispatch, id: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/reSell/factoring/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const updateFactoringReSell = async (
  dispatch: Dispatch,
  id: string,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/reSell/factoring/${id}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};
export const updateFactoringReSellBatch = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/reSell/factoring/batch`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getResellFactoringMissingApprovals = async (
  dispatch: Dispatch,
  id: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/reSell/factoring/${id}/approvals`,
    dispatch,
  });
  if (response) return response.data;
};

export const approveResell = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/reSell/factoring/${id}/approve`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const rejectResell = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/reSell/factoring/${id}/reject`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getResellPayments = async (dispatch: Dispatch, id: number) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/reSell/factoring/${id}/payments`,
    dispatch,
  });
  if (response) return response.data;
};

export const getAECsInPosession = async (
  dispatch: Dispatch,
  documentIds: {
    id: string;
    folio: string;
    businessIdentifier: string;
    cessionDate: Date;
  }[],
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/reSell/getAecToResell`,
    data: { documentIds, useLegacy: true },
    dispatch,
  });
  if (response) return response.data;
};

export const downloadAEC = async (
  dispatch: Dispatch,
  documentIds: string[],
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/reSell/downloadAEC`,
    data: { documentIds },
    dispatch,
  });
  if (response) return response.data;
};

export const executeRecesion = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/reSell/executeReCesion`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentsPreparedForResell = async (
  dispatch: Dispatch,
  documentIds: string[],
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/reSell/factoring/prepareDocumentsForResell`,
    data: { documentIds },
    dispatch,
  });
  if (response) return response.data;
};

export const getSuggestedResellsForConciliation = async (
  dispatch: Dispatch,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/reSell/suggestedConciliation?${query}`,
    dispatch,
  });
  if (response) return response.data;
};
